module.exports = __webpack_public_path__ + "9ff0f34f525250b89f9427f6c57c26a4.MP3";